import VisibilityIcon from "@mui/icons-material/Visibility";
import { Collapse, Tooltip } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import React, { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AccessLevelDTO } from "../../../Services/DTO/Settings/AccessLevel/AccessLevelDTO";
import "../../../formLayout.scss";
import EditIcon from "@mui/icons-material/Edit";
import DownloadIcon from "@mui/icons-material/Download";
import FileUploadRoundedIcon from "@mui/icons-material/FileUploadRounded";
import AddCircleOutlineRoundedIcon from "@mui/icons-material/AddCircleOutlineRounded";
import RemoveRoundedIcon from "@mui/icons-material/RemoveRounded";
import EmojiFlagsRoundedIcon from "@mui/icons-material/EmojiFlagsRounded";

interface Props {
  open_status: boolean;
  attrName: any;
  value_update: Function;
}

function ModulePermissionAccessControl() {
  const navigate = useNavigate();
  const [roleName, setRoleName] = React.useState("");
  const [deleteStatus, setDeleteStatus] = React.useState(false);
  const [expanded, setExpanded] = React.useState<string | false>("panel1");
  const [sectionStatus, SetSectionStatus] =
    React.useState<string>("roleInformation");
  const [subSection, setSubSection] = React.useState<string>("rolename");
  const [unusedFields, setUnusedFields] = React.useState(false);
  const openUnusedFields = () => {
    setUnusedFields((expanded) => !expanded);
  };
  const [unusedFieldsOne, setUnusedFieldsOne] = React.useState(false);
  const openUnusedFieldsOne = () => {
    setUnusedFieldsOne((expanded) => !expanded);
  };

  const updateMasterState = (attrName: any, value: any) => {
    attrName(value);
  };

  // for scrolling
  const modulePermission = useRef(null);

  const [module_permission_data, set_module_permission_data] = useState<
    AccessLevelDTO[]
  >([
    {
      data: {
        module_name: "Dashboard",
        id: "AB01",
        view: { check: false, disable: false },
        edit: { check: true, disable: true },
        csv: { check: false, disable: true },
        upload: { check: true, disable: false },
        status: { check: false, disable: false },
        add: { check: true, disable: true },
        remove: { check: false, disable: true },
      },
    },
    {
      data: {
        module_name: "Quotes",
        id: "AB02",
        view: { check: true, disable: false },
        edit: { check: false, disable: true },
        csv: { check: false, disable: false },
        upload: { check: true, disable: true },
        status: { check: false, disable: true },
        add: { check: true, disable: false },
        remove: { check: false, disable: false },
      },
    },
    {
      data: {
        module_name: "Policies",
        id: "AB03",
        view: { check: false, disable: true },
        edit: { check: false, disable: false },
        csv: { check: true, disable: true },
        upload: { check: false, disable: true },
        status: { check: true, disable: false },
        add: { check: false, disable: false },
        remove: { check: true, disable: true },
      },
    },
    {
      data: {
        module_name: "Renewals",
        id: "AB04",
        view: { check: false, disable: false },
        edit: { check: true, disable: true },
        csv: { check: false, disable: true },
        upload: { check: true, disable: false },
        status: { check: false, disable: false },
        add: { check: true, disable: true },
        remove: { check: true, disable: false },
      },
    },
    {
      data: {
        module_name: "Clients",
        id: "AB05",
        view: { check: true, disable: false },
        edit: { check: false, disable: true },
        csv: { check: false, disable: false },
        upload: { check: true, disable: true },
        status: { check: false, disable: true },
        add: { check: true, disable: false },
        remove: { check: false, disable: false },
      },
    },
    {
      data: {
        module_name: "Contact",
        id: "AB06",
        view: { check: false, disable: true },
        edit: { check: false, disable: false },
        csv: { check: true, disable: true },
        upload: { check: false, disable: true },
        status: { check: true, disable: false },
        add: { check: false, disable: false },
        remove: { check: true, disable: true },
      },
    },
    {
      data: {
        module_name: "Employees",
        id: "AB07",
        view: { check: false, disable: false },
        edit: { check: true, disable: true },
        csv: { check: false, disable: true },
        upload: { check: true, disable: false },
        status: { check: false, disable: false },
        add: { check: true, disable: true },
        remove: { check: true, disable: false },
      },
    },
    {
      data: {
        module_name: "Product Configurator",
        id: "AB08",
        view: { check: true, disable: false },
        edit: { check: false, disable: true },
        csv: { check: false, disable: false },
        upload: { check: true, disable: true },
        status: { check: false, disable: true },
        add: { check: true, disable: false },
        remove: { check: true, disable: true },
      },
    },
    {
      data: {
        module_name: "Endorsement",
        id: "AB09",
        view: { check: true, disable: false },
        edit: { check: false, disable: true },
        csv: { check: false, disable: false },
        upload: { check: true, disable: true },
        status: { check: false, disable: true },
        add: { check: true, disable: false },
        remove: { check: false, disable: false },
      },
    },
    {
      data: {
        module_name: "Claims",
        id: "AB10",
        view: { check: false, disable: false },
        edit: { check: true, disable: true },
        csv: { check: false, disable: true },
        upload: { check: true, disable: false },
        status: { check: false, disable: false },
        add: { check: true, disable: true },
        remove: { check: false, disable: true },
      },
    },
    {
      data: {
        module_name: "Reports",
        id: "AB11",
        view: { check: true, disable: false },
        edit: { check: false, disable: true },
        csv: { check: false, disable: false },
        upload: { check: true, disable: true },
        status: { check: false, disable: true },
        add: { check: true, disable: false },
        remove: { check: true, disable: true },
      },
    },
    {
      data: {
        module_name: "Support",
        id: "AB12",
        view: { check: true, disable: false },
        edit: { check: false, disable: true },
        csv: { check: false, disable: false },
        upload: { check: true, disable: true },
        status: { check: false, disable: true },
        add: { check: true, disable: false },
        remove: { check: false, disable: true },
      },
    },
    {
      data: {
        module_name: "Settings",
        id: "AB13",
        view: { check: false, disable: false },
        edit: { check: true, disable: true },
        csv: { check: false, disable: true },
        upload: { check: true, disable: false },
        status: { check: false, disable: false },
        add: { check: true, disable: true },
        remove: { check: false, disable: false },
      },
      child_open_status: false,
      child: [
        {
          data: {
            module_name: "General",
            id: "AB0111",
            view: { check: false, disable: false },
            edit: { check: false, disable: false },
            csv: { check: false, disable: false },
            upload: { check: false, disable: false },
            status: { check: false, disable: false },
            add: { check: false, disable: false },
            remove: { check: true, disable: true },
          },
          child_open_status: false,
          child: [
            {
              data: {
                module_name: "Support",
                id: "AB0121",
                view: { check: true, disable: false },
                edit: { check: false, disable: true },
                csv: { check: false, disable: false },
                upload: { check: true, disable: true },
                status: { check: false, disable: true },
                add: { check: true, disable: false },
                remove: { check: false, disable: true },
              },
            },
            {
              data: {
                module_name: "Email Setting",
                id: "AB0122",
                view: { check: true, disable: false },
                edit: { check: false, disable: true },
                csv: { check: false, disable: false },
                upload: { check: true, disable: true },
                status: { check: false, disable: true },
                add: { check: true, disable: false },
                remove: { check: false, disable: false },
              },
            },
            {
              data: {
                module_name: "Appearance",
                id: "AB0123",
                view: { check: true, disable: false },
                edit: { check: false, disable: true },
                csv: { check: false, disable: false },
                upload: { check: true, disable: true },
                status: { check: false, disable: true },
                add: { check: true, disable: false },
                remove: { check: true, disable: true },
              },
            },
          ],
        },
        {
          data: {
            module_name: "Organisation",
            id: "OR01",
            view: { check: false, disable: false },
            edit: { check: false, disable: false },
            csv: { check: false, disable: false },
            upload: { check: false, disable: false },
            status: { check: false, disable: false },
            add: { check: false, disable: false },
            remove: { check: false, disable: true },
          },
          child_open_status: false,
          child: [
            {
              data: {
                module_name: "Company details",
                id: "OR011",
                view: { check: true, disable: false },
                edit: { check: false, disable: true },
                csv: { check: false, disable: false },
                upload: { check: true, disable: true },
                status: { check: false, disable: true },
                add: { check: true, disable: false },
                remove: { check: false, disable: false },
              },
            },
            {
              data: {
                module_name: "Branches",
                id: "OR012",
                view: { check: true, disable: false },
                edit: { check: false, disable: true },
                csv: { check: false, disable: false },
                upload: { check: true, disable: true },
                status: { check: false, disable: true },
                add: { check: true, disable: false },
                remove: { check: true, disable: true },
              },
            },
            {
              data: {
                module_name: "Department",
                id: "OR013",
                view: { check: true, disable: false },
                edit: { check: false, disable: true },
                csv: { check: false, disable: false },
                upload: { check: true, disable: true },
                status: { check: false, disable: true },
                add: { check: true, disable: false },
                remove: { check: false, disable: true },
              },
            },
            {
              data: {
                module_name: "Taxation",
                id: "OR014",
                view: { check: false, disable: false },
                edit: { check: false, disable: false },
                csv: { check: false, disable: false },
                upload: { check: false, disable: false },
                status: { check: false, disable: false },
                add: { check: false, disable: false },
                remove: { check: true, disable: false },
              },
            },
            {
              data: {
                module_name: "Currencies",
                id: "OR015",
                view: { check: true, disable: false },
                edit: { check: false, disable: true },
                csv: { check: false, disable: false },
                upload: { check: true, disable: true },
                status: { check: false, disable: true },
                add: { check: true, disable: false },
                remove: { check: false, disable: false },
              },
            },
          ],
        },
        {
          data: {
            module_name: "User And Controls",
            id: "US01",
            view: { check: false, disable: false },
            edit: { check: false, disable: false },
            csv: { check: false, disable: false },
            upload: { check: false, disable: false },
            status: { check: false, disable: false },
            add: { check: false, disable: false },
            remove: { check: false, disable: true },
          },
          child_open_status: false,
          child: [
            {
              data: {
                module_name: "Users",
                id: "US011",
                view: { check: true, disable: false },
                edit: { check: false, disable: true },
                csv: { check: false, disable: false },
                upload: { check: true, disable: true },
                status: { check: false, disable: true },
                add: { check: true, disable: false },
                remove: { check: true, disable: true },
              },
            },
            {
              data: {
                module_name: "Access Control",
                id: "US012",
                view: { check: true, disable: false },
                edit: { check: false, disable: true },
                csv: { check: false, disable: false },
                upload: { check: true, disable: true },
                status: { check: false, disable: true },
                add: { check: true, disable: false },
                remove: { check: false, disable: false },
              },
            },
          ],
        },
        {
          data: {
            module_name: "Customisation",
            id: "CS01",
            view: { check: false, disable: false },
            edit: { check: false, disable: false },
            csv: { check: false, disable: false },
            upload: { check: false, disable: false },
            status: { check: false, disable: false },
            add: { check: false, disable: false },
            remove: { check: true, disable: true },
          },
          child_open_status: false,
          child: [
            {
              data: {
                module_name: "Users",
                id: "CS011",
                view: { check: false, disable: false },
                edit: { check: true, disable: true },
                csv: { check: false, disable: true },
                upload: { check: true, disable: false },
                status: { check: false, disable: false },
                add: { check: true, disable: true },
                remove: { check: true, disable: false },
              },
            },
            {
              data: {
                module_name: "Access Control",
                id: "CS012",
                view: { check: true, disable: false },
                edit: { check: false, disable: false },
                csv: { check: false, disable: true },
                upload: { check: true, disable: true },
                status: { check: false, disable: true },
                add: { check: false, disable: false },
                remove: { check: false, disable: true },
              },
            },
          ],
        },
        {
          data: {
            module_name: "Portal Setup",
            id: "PS01",
            view: { check: false, disable: false },
            edit: { check: false, disable: false },
            csv: { check: false, disable: false },
            upload: { check: false, disable: false },
            status: { check: false, disable: false },
            add: { check: false, disable: false },
            remove: { check: true, disable: true },
          },
          child_open_status: false,
          child: [
            {
              data: {
                module_name: "Employee Portal",
                id: "PS011",
                view: { check: false, disable: false },
                edit: { check: true, disable: false },
                csv: { check: true, disable: true },
                upload: { check: false, disable: false },
                status: { check: true, disable: false },
                add: { check: false, disable: true },
                remove: { check: false, disable: false },
              },
            },
            {
              data: {
                module_name: "Employer Portal",
                id: "PS012",
                view: { check: true, disable: false },
                edit: { check: false, disable: false },
                csv: { check: false, disable: true },
                upload: { check: true, disable: true },
                status: { check: false, disable: true },
                add: { check: false, disable: false },
                remove: { check: true, disable: true },
              },
            },
          ],
        },
        {
          data: {
            module_name: "Data Admin",
            id: "DA01",
            view: { check: false, disable: false },
            edit: { check: false, disable: false },
            csv: { check: false, disable: false },
            upload: { check: false, disable: false },
            status: { check: false, disable: false },
            add: { check: false, disable: false },
            remove: { check: false, disable: true },
          },
          child_open_status: false,
          child: [
            {
              data: {
                module_name: "Storage",
                id: "DA011",
                view: { check: false, disable: true },
                edit: { check: true, disable: false },
                csv: { check: false, disable: false },
                upload: { check: true, disable: true },
                status: { check: false, disable: false },
                add: { check: true, disable: false },
                remove: { check: false, disable: false },
              },
            },
            {
              data: {
                module_name: "Export",
                id: "DA012",
                view: { check: true, disable: false },
                edit: { check: false, disable: false },
                csv: { check: true, disable: true },
                upload: { check: false, disable: true },
                status: { check: true, disable: false },
                add: { check: false, disable: false },
                remove: { check: true, disable: true },
              },
            },
            {
              data: {
                module_name: "Activity Log",
                id: "DA013",
                view: { check: true, disable: true },
                edit: { check: true, disable: false },
                csv: { check: false, disable: false },
                upload: { check: false, disable: true },
                status: { check: true, disable: false },
                add: { check: false, disable: false },
                remove: { check: false, disable: true },
              },
            },
            {
              data: {
                module_name: "Audit Log",
                id: "DA014",
                view: { check: false, disable: true },
                edit: { check: true, disable: false },
                csv: { check: false, disable: false },
                upload: { check: true, disable: true },
                status: { check: false, disable: false },
                add: { check: true, disable: false },
                remove: { check: false, disable: false },
              },
            },
          ],
        },
        {
          data: {
            module_name: "Developer Space",
            id: "DS01",
            view: { check: false, disable: false },
            edit: { check: false, disable: false },
            csv: { check: false, disable: false },
            upload: { check: false, disable: false },
            status: { check: false, disable: false },
            add: { check: false, disable: false },
            remove: { check: true, disable: true },
          },
          child_open_status: false,
          child: [
            {
              data: {
                module_name: "Integration",
                id: "DS011",
                view: { check: false, disable: false },
                edit: { check: true, disable: false },
                csv: { check: true, disable: true },
                upload: { check: false, disable: false },
                status: { check: true, disable: false },
                add: { check: false, disable: true },
                remove: { check: false, disable: false },
              },
            },
            {
              data: {
                module_name: "API & Webhooks",
                id: "DS012",
                view: { check: false, disable: true },
                edit: { check: true, disable: false },
                csv: { check: false, disable: false },
                upload: { check: true, disable: true },
                status: { check: false, disable: false },
                add: { check: true, disable: false },
                remove: { check: true, disable: true },
              },
            },
          ],
        },
      ],
    },
  ]);

  const updateStatus = (
    id: Array<string>,
    updateValue: boolean,
    key: keyof any
  ) => {
    const data: any[] = [...module_permission_data];

    if (id.length === 1) {
      const index = data.findIndex((obj: any) => obj.data.id == id[0]);

      if (key === "child_open_status") {
        data[index] = { ...data[index], [key]: updateValue };
      } else {
        data[index].data[key] = !data[index].data[key];
      }
    } else if (id.length === 2) {
      const parent_index = data.findIndex((obj: any) => obj.data.id == id[0]);
      const parent_data = data[parent_index];

      const child_index = parent_data.child.findIndex(
        (obj: any) => obj.data.id == id[1]
      );
      const child_data = parent_data.child[child_index];

      if (key === "child_open_status") {
        data[parent_index].child[child_index].child_open_status =
          !data[parent_index].child[child_index].child_open_status;
      } else {
        data[parent_index].child[child_index].data[key] =
          !data[parent_index].child[child_index].data[key];
      }
    } else if (id.length === 3) {
      const parent_index = data.findIndex((obj: any) => obj.data.id == id[0]);
      const parent_data = data[parent_index];

      const child_index = parent_data.child.findIndex(
        (obj: any) => obj.data.id == id[1]
      );
      const child_data = parent_data.child[child_index];

      const child_of_child_index = child_data.child.findIndex(
        (obj: any) => obj.data.id == id[2]
      );
      const child_of_child_data = parent_data.child[child_index];

      if (key === "child_open_status") {
        data[parent_index].child[child_index].child_open_status =
          !data[parent_index].child[child_index].child_open_status;
      } else {
        data[parent_index].child[child_index].child[child_of_child_index].data[
          key
        ] =
          !data[parent_index].child[child_index].child[child_of_child_index]
            .data[key];
      }
    }
    set_module_permission_data(data);
  };

  return (
    <div ref={modulePermission}>
      <Grid container spacing={3}>
        <Grid xs={12}>
          <h5 className="subHeading">Module Permission</h5>
        </Grid>
      </Grid>
      <Grid container spacing={3}>
        <Grid xs={12}>
          <div className="module_table">
            <div
              className="module_permission_table"
              style={{ overflow: "hidden" }}
            >
              <ul className="heading">
                <li>Module Name</li>
                <li>
                  <VisibilityIcon />
                  View
                </li>
                <li>
                  <EditIcon />
                  Edit
                </li>
                <li>
                  <DownloadIcon />
                  CSV (Download)
                </li>
                <li>
                  <FileUploadRoundedIcon />
                  Bulk Upload
                </li>
                <li>
                  <EmojiFlagsRoundedIcon />
                  Status
                </li>
                <li>
                  <AddCircleOutlineRoundedIcon />
                  Add
                </li>
                <li>
                  <RemoveRoundedIcon />
                  Remove
                </li>
              </ul>
              <div className="module_table_inner">
                {module_permission_data.map((data, index) => (
                  <>
                    {
                      <ul className="subheading parent">
                        <li
                          className={
                            data.data.module_name === "Settings" &&
                            data.child_open_status === false &&
                            data.data.id === "AB13"
                              ? "collapse_plus setting_plus"
                              : data.data.module_name === "Settings" &&
                                data.child_open_status === true &&
                                data.data.id === "AB13"
                              ? "collapse_minus setting_minus"
                              : ""
                          }
                        >
                          <p
                            onClick={() => {
                              updateStatus(
                                [data.data.id],
                                !data.child_open_status,
                                "child_open_status"
                              );
                            }}
                          >
                            {data.data.module_name}
                          </p>

                          {data.child_open_status ? (
                            <Collapse in={data.child_open_status}>
                              {data?.child?.map((child_data, index) => (
                                <>
                                  <ul
                                    className={
                                      child_data.child_open_status === true
                                        ? "subheading child collapse_minus"
                                        : "subheading child collapse_plus"
                                    }
                                  >
                                    <li>
                                      <p
                                        className="setting_parent"
                                        onClick={() => {
                                          updateStatus(
                                            [data.data.id, child_data.data.id],
                                            !child_data.child_open_status,
                                            "child_open_status"
                                          );
                                        }}
                                      >
                                        {child_data.data.module_name}
                                      </p>
                                      {child_data.child_open_status ? (
                                        <Collapse
                                          in={child_data.child_open_status}
                                        >
                                          {child_data?.child?.map(
                                            (child_of_child_data, index) => (
                                              <>
                                                <ul
                                                  className={
                                                    (child_data?.child
                                                      ?.length === undefined
                                                      ? 0
                                                      : child_data?.child
                                                          ?.length - 1) ===
                                                    index
                                                      ? "subheading childofchild module_table_line_last"
                                                      : "subheading childofchild module_table_lines"
                                                  }
                                                >
                                                  <li>
                                                    {
                                                      child_of_child_data.data
                                                        .module_name
                                                    }
                                                  </li>
                                                  <li>
                                                    <div className="Checkbox">
                                                      <Tooltip
                                                        title={
                                                          child_of_child_data
                                                            .data.view
                                                            .disable === true
                                                            ? "Feature not available"
                                                            : ""
                                                        }
                                                      >
                                                        <input
                                                          type="checkbox"
                                                          name="check"
                                                          checked={
                                                            child_of_child_data
                                                              .data.view.check
                                                          }
                                                          defaultChecked={
                                                            child_of_child_data
                                                              .data.view.check
                                                          }
                                                          onChange={(e) => {
                                                            if (
                                                              !child_of_child_data
                                                                .data.view
                                                                .disable
                                                            ) {
                                                              updateStatus(
                                                                [
                                                                  data.data.id,
                                                                  child_data
                                                                    .data.id,
                                                                  child_of_child_data
                                                                    .data.id,
                                                                ],
                                                                e.target
                                                                  .checked,
                                                                "view"
                                                              );
                                                            }
                                                          }}
                                                        />
                                                      </Tooltip>
                                                      <label className="view"></label>
                                                    </div>
                                                  </li>
                                                  <li>
                                                    <div className="Checkbox">
                                                      <Tooltip
                                                        title={
                                                          child_of_child_data
                                                            .data.edit
                                                            .disable === true
                                                            ? "Feature not available"
                                                            : ""
                                                        }
                                                      >
                                                        <input
                                                          type="checkbox"
                                                          name="check"
                                                          checked={
                                                            child_of_child_data
                                                              .data.edit.check
                                                          }
                                                          defaultChecked={
                                                            child_of_child_data
                                                              .data.edit.check
                                                          }
                                                          onChange={(e) => {
                                                            if (
                                                              !child_of_child_data
                                                                .data.edit
                                                                .disable
                                                            ) {
                                                              updateStatus(
                                                                [
                                                                  data.data.id,
                                                                  child_data
                                                                    .data.id,
                                                                  child_of_child_data
                                                                    .data.id,
                                                                ],
                                                                e.target
                                                                  .checked,
                                                                "edit"
                                                              );
                                                            }
                                                          }}
                                                        />
                                                      </Tooltip>
                                                      <label className="edit"></label>
                                                    </div>
                                                  </li>
                                                  <li>
                                                    <div className="Checkbox">
                                                      <Tooltip
                                                        title={
                                                          child_of_child_data
                                                            .data.csv
                                                            .disable === true
                                                            ? "Feature not available"
                                                            : ""
                                                        }
                                                      >
                                                        <input
                                                          type="checkbox"
                                                          name="check"
                                                          checked={
                                                            child_of_child_data
                                                              .data.csv.check
                                                          }
                                                          defaultChecked={
                                                            child_of_child_data
                                                              .data.csv.check
                                                          }
                                                          onChange={(e) => {
                                                            if (
                                                              !child_of_child_data
                                                                .data.csv
                                                                .disable
                                                            ) {
                                                              updateStatus(
                                                                [
                                                                  data.data.id,
                                                                  child_data
                                                                    .data.id,
                                                                  child_of_child_data
                                                                    .data.id,
                                                                ],
                                                                e.target
                                                                  .checked,
                                                                "csv"
                                                              );
                                                            }
                                                          }}
                                                        />
                                                      </Tooltip>
                                                      <label className="csv"></label>
                                                    </div>
                                                  </li>
                                                  <li>
                                                    <div className="Checkbox">
                                                      <Tooltip
                                                        title={
                                                          child_of_child_data
                                                            .data.upload
                                                            .disable === true
                                                            ? "Feature not available"
                                                            : ""
                                                        }
                                                      >
                                                        <input
                                                          type="checkbox"
                                                          name="check"
                                                          checked={
                                                            child_of_child_data
                                                              .data.upload.check
                                                          }
                                                          defaultChecked={
                                                            child_of_child_data
                                                              .data.upload.check
                                                          }
                                                          onChange={(e) => {
                                                            if (
                                                              !child_of_child_data
                                                                .data.upload
                                                                .disable
                                                            ) {
                                                              updateStatus(
                                                                [
                                                                  data.data.id,
                                                                  child_data
                                                                    .data.id,
                                                                  child_of_child_data
                                                                    .data.id,
                                                                ],
                                                                e.target
                                                                  .checked,
                                                                "upload"
                                                              );
                                                            }
                                                          }}
                                                        />
                                                      </Tooltip>
                                                      <label className="upload"></label>
                                                    </div>
                                                  </li>
                                                  <li>
                                                    <div className="Checkbox">
                                                      <Tooltip
                                                        title={
                                                          child_of_child_data
                                                            .data.status
                                                            .disable === true
                                                            ? "Feature not available"
                                                            : ""
                                                        }
                                                      >
                                                        <input
                                                          type="checkbox"
                                                          name="check"
                                                          checked={
                                                            child_of_child_data
                                                              .data.status.check
                                                          }
                                                          defaultChecked={
                                                            child_of_child_data
                                                              .data.status.check
                                                          }
                                                          onChange={(e) => {
                                                            if (
                                                              !child_of_child_data
                                                                .data.status
                                                                .disable
                                                            ) {
                                                              updateStatus(
                                                                [
                                                                  data.data.id,
                                                                  child_data
                                                                    .data.id,
                                                                  child_of_child_data
                                                                    .data.id,
                                                                ],
                                                                e.target
                                                                  .checked,
                                                                "status"
                                                              );
                                                            }
                                                          }}
                                                        />
                                                      </Tooltip>
                                                      <label className="status"></label>
                                                    </div>
                                                  </li>
                                                  <li>
                                                    <div className="Checkbox">
                                                      <Tooltip
                                                        title={
                                                          child_of_child_data
                                                            .data.add
                                                            .disable === true
                                                            ? "Feature not available"
                                                            : ""
                                                        }
                                                      >
                                                        <input
                                                          type="checkbox"
                                                          name="check"
                                                          checked={
                                                            child_of_child_data
                                                              .data.add.check
                                                          }
                                                          defaultChecked={
                                                            child_of_child_data
                                                              .data.add.check
                                                          }
                                                          onChange={(e) => {
                                                            if (
                                                              !child_of_child_data
                                                                .data.add
                                                                .disable
                                                            ) {
                                                              updateStatus(
                                                                [
                                                                  data.data.id,
                                                                  child_data
                                                                    .data.id,
                                                                  child_of_child_data
                                                                    .data.id,
                                                                ],
                                                                e.target
                                                                  .checked,
                                                                "add"
                                                              );
                                                            }
                                                          }}
                                                        />
                                                      </Tooltip>
                                                      <label className="add"></label>
                                                    </div>
                                                  </li>
                                                  <li>
                                                    <div className="Checkbox">
                                                      <Tooltip
                                                        title={
                                                          child_of_child_data
                                                            .data.remove
                                                            .disable === true
                                                            ? "Feature not available"
                                                            : ""
                                                        }
                                                      >
                                                        <input
                                                          type="checkbox"
                                                          name="check"
                                                          checked={
                                                            child_of_child_data
                                                              .data.remove.check
                                                          }
                                                          defaultChecked={
                                                            child_of_child_data
                                                              .data.remove.check
                                                          }
                                                          onChange={(e) => {
                                                            if (
                                                              !child_of_child_data
                                                                .data.remove
                                                                .disable
                                                            ) {
                                                              updateStatus(
                                                                [
                                                                  data.data.id,
                                                                  child_data
                                                                    .data.id,
                                                                  child_of_child_data
                                                                    .data.id,
                                                                ],
                                                                e.target
                                                                  .checked,
                                                                "remove"
                                                              );
                                                            }
                                                          }}
                                                        />
                                                      </Tooltip>
                                                      <label className="remove"></label>
                                                    </div>
                                                  </li>
                                                </ul>
                                              </>
                                            )
                                          )}
                                        </Collapse>
                                      ) : null}
                                    </li>
                                    {child_data?.child === undefined ? (
                                      <>
                                        <li>
                                          <div className="Checkbox">
                                            <input
                                              type="checkbox"
                                              name="check"
                                              checked={
                                                child_data.data.view.check
                                              }
                                              defaultChecked={
                                                child_data.data.view.check
                                              }
                                              disabled={
                                                child_data.data.view.disable
                                              }
                                              onChange={(e) => {
                                                updateStatus(
                                                  [
                                                    data.data.id,
                                                    child_data.data.id,
                                                  ],
                                                  e.target.checked,
                                                  "view"
                                                );
                                              }}
                                            />
                                            <label className="view"></label>
                                          </div>
                                        </li>
                                        <li>
                                          <div className="Checkbox">
                                            <input
                                              type="checkbox"
                                              name="check"
                                              checked={
                                                child_data.data.edit.check
                                              }
                                              defaultChecked={
                                                child_data.data.edit.check
                                              }
                                              disabled={
                                                child_data.data.edit.disable
                                              }
                                              onChange={(e) => {
                                                updateStatus(
                                                  [
                                                    data.data.id,
                                                    child_data.data.id,
                                                  ],
                                                  e.target.checked,
                                                  "edit"
                                                );
                                              }}
                                            />
                                            <label className="edit"></label>
                                          </div>
                                        </li>
                                        <li>
                                          <div className="Checkbox">
                                            <input
                                              type="checkbox"
                                              name="check"
                                              checked={
                                                child_data.data.csv.check
                                              }
                                              defaultChecked={
                                                child_data.data.csv.check
                                              }
                                              disabled={
                                                child_data.data.csv.disable
                                              }
                                              onChange={(e) => {
                                                updateStatus(
                                                  [
                                                    data.data.id,
                                                    child_data.data.id,
                                                  ],
                                                  e.target.checked,
                                                  "csv"
                                                );
                                              }}
                                            />
                                            <label className="csv"></label>
                                          </div>
                                        </li>
                                        <li>
                                          <div className="Checkbox">
                                            <input
                                              type="checkbox"
                                              name="check"
                                              checked={
                                                child_data.data.upload.check
                                              }
                                              defaultChecked={
                                                child_data.data.upload.check
                                              }
                                              disabled={
                                                child_data.data.upload.disable
                                              }
                                              onChange={(e) => {
                                                updateStatus(
                                                  [
                                                    data.data.id,
                                                    child_data.data.id,
                                                  ],
                                                  e.target.checked,
                                                  "upload"
                                                );
                                              }}
                                            />
                                            <label className="upload"></label>
                                          </div>
                                        </li>
                                        <li>
                                          <div className="Checkbox">
                                            <input
                                              type="checkbox"
                                              name="check"
                                              checked={
                                                child_data.data.status.check
                                              }
                                              defaultChecked={
                                                child_data.data.status.check
                                              }
                                              disabled={
                                                child_data.data.status.disable
                                              }
                                              onChange={(e) => {
                                                updateStatus(
                                                  [
                                                    data.data.id,
                                                    child_data.data.id,
                                                  ],
                                                  e.target.checked,
                                                  "status"
                                                );
                                              }}
                                            />
                                            <label className="status"></label>
                                          </div>
                                        </li>
                                        <li>
                                          <div className="Checkbox">
                                            <input
                                              type="checkbox"
                                              name="check"
                                              checked={
                                                child_data.data.add.check
                                              }
                                              defaultChecked={
                                                child_data.data.add.check
                                              }
                                              disabled={
                                                child_data.data.add.disable
                                              }
                                              onChange={(e) => {
                                                updateStatus(
                                                  [
                                                    data.data.id,
                                                    child_data.data.id,
                                                  ],
                                                  e.target.checked,
                                                  "add"
                                                );
                                              }}
                                            />
                                            <label className="add"></label>
                                          </div>
                                        </li>
                                        <li>
                                          <div className="Checkbox">
                                            <input
                                              type="checkbox"
                                              name="check"
                                              checked={
                                                child_data.data.remove.check
                                              }
                                              defaultChecked={
                                                child_data.data.remove.check
                                              }
                                              disabled={
                                                child_data.data.remove.disable
                                              }
                                              onChange={(e) => {
                                                updateStatus(
                                                  [
                                                    data.data.id,
                                                    child_data.data.id,
                                                  ],
                                                  e.target.checked,
                                                  "remove"
                                                );
                                              }}
                                            />
                                            <label className="remove"></label>
                                          </div>
                                        </li>
                                      </>
                                    ) : child_data?.child.length === 0 ? (
                                      <>
                                        <li>
                                          <div className="Checkbox">
                                            <input
                                              type="checkbox"
                                              name="check"
                                              checked={
                                                child_data.data.view.check
                                              }
                                              defaultChecked={
                                                child_data.data.view.check
                                              }
                                              disabled={
                                                child_data.data.view.disable
                                              }
                                              onChange={(e) => {
                                                updateStatus(
                                                  [
                                                    data.data.id,
                                                    child_data.data.id,
                                                  ],
                                                  e.target.checked,
                                                  "view"
                                                );
                                              }}
                                            />
                                            <label className="view"></label>
                                          </div>
                                        </li>
                                        <li>
                                          <div className="Checkbox">
                                            <input
                                              type="checkbox"
                                              name="check"
                                              checked={
                                                child_data.data.edit.check
                                              }
                                              defaultChecked={
                                                child_data.data.edit.check
                                              }
                                              disabled={
                                                child_data.data.edit.disable
                                              }
                                              onChange={(e) => {
                                                updateStatus(
                                                  [
                                                    data.data.id,
                                                    child_data.data.id,
                                                  ],
                                                  e.target.checked,
                                                  "edit"
                                                );
                                              }}
                                            />
                                            <label className="edit"></label>
                                          </div>
                                        </li>
                                        <li>
                                          <div className="Checkbox">
                                            <input
                                              type="checkbox"
                                              name="check"
                                              checked={
                                                child_data.data.csv.check
                                              }
                                              defaultChecked={
                                                child_data.data.csv.check
                                              }
                                              disabled={
                                                child_data.data.csv.disable
                                              }
                                              onChange={(e) => {
                                                updateStatus(
                                                  [
                                                    data.data.id,
                                                    child_data.data.id,
                                                  ],
                                                  e.target.checked,
                                                  "csv"
                                                );
                                              }}
                                            />
                                            <label className="csv"></label>
                                          </div>
                                        </li>
                                        <li>
                                          <div className="Checkbox">
                                            <input
                                              type="checkbox"
                                              name="check"
                                              checked={
                                                child_data.data.upload.check
                                              }
                                              defaultChecked={
                                                child_data.data.upload.check
                                              }
                                              disabled={
                                                child_data.data.upload.disable
                                              }
                                              onChange={(e) => {
                                                updateStatus(
                                                  [
                                                    data.data.id,
                                                    child_data.data.id,
                                                  ],
                                                  e.target.checked,
                                                  "upload"
                                                );
                                              }}
                                            />
                                            <label className="upload"></label>
                                          </div>
                                        </li>
                                        <li>
                                          <div className="Checkbox">
                                            <input
                                              type="checkbox"
                                              name="check"
                                              checked={
                                                child_data.data.status.check
                                              }
                                              defaultChecked={
                                                child_data.data.status.check
                                              }
                                              disabled={
                                                child_data.data.status.disable
                                              }
                                              onChange={(e) => {
                                                updateStatus(
                                                  [
                                                    data.data.id,
                                                    child_data.data.id,
                                                  ],
                                                  e.target.checked,
                                                  "status"
                                                );
                                              }}
                                            />
                                            <label className="status"></label>
                                          </div>
                                        </li>
                                        <li>
                                          <div className="Checkbox">
                                            <input
                                              type="checkbox"
                                              name="check"
                                              checked={
                                                child_data.data.add.check
                                              }
                                              defaultChecked={
                                                child_data.data.add.check
                                              }
                                              disabled={
                                                child_data.data.add.disable
                                              }
                                              onChange={(e) => {
                                                updateStatus(
                                                  [
                                                    data.data.id,
                                                    child_data.data.id,
                                                  ],
                                                  e.target.checked,
                                                  "add"
                                                );
                                              }}
                                            />
                                            <label className="add"></label>
                                          </div>
                                        </li>
                                        <li>
                                          <div className="Checkbox">
                                            <input
                                              type="checkbox"
                                              name="check"
                                              checked={
                                                child_data.data.remove.check
                                              }
                                              defaultChecked={
                                                child_data.data.remove.check
                                              }
                                              disabled={
                                                child_data.data.remove.disable
                                              }
                                              onChange={(e) => {
                                                updateStatus(
                                                  [
                                                    data.data.id,
                                                    child_data.data.id,
                                                  ],
                                                  e.target.checked,
                                                  "remove"
                                                );
                                              }}
                                            />
                                            <label className="remove"></label>
                                          </div>
                                        </li>
                                      </>
                                    ) : null}
                                  </ul>
                                </>
                              ))}
                            </Collapse>
                          ) : null}
                        </li>
                        {data?.child === undefined ? (
                          <>
                            <li>
                              <div className="Checkbox">
                                <input
                                  type="checkbox"
                                  name="check"
                                  checked={data.data.view.check}
                                  defaultChecked={data.data.view.check}
                                  disabled={data.data.view.disable}
                                  onChange={(e) => {
                                    updateStatus(
                                      [data.data.id],
                                      e.target.checked,
                                      "view"
                                    );
                                  }}
                                />
                                <label className="view"></label>
                              </div>
                            </li>
                            <li>
                              <div className="Checkbox">
                                <input
                                  type="checkbox"
                                  name="check"
                                  checked={data.data.edit.check}
                                  defaultChecked={data.data.edit.check}
                                  disabled={data.data.edit.disable}
                                  onChange={(e) => {
                                    updateStatus(
                                      [data.data.id],
                                      e.target.checked,
                                      "edit"
                                    );
                                  }}
                                />
                                <label className="edit"></label>
                              </div>
                            </li>
                            <li>
                              <div className="Checkbox">
                                <input
                                  type="checkbox"
                                  name="check"
                                  checked={data.data.csv.check}
                                  defaultChecked={data.data.csv.check}
                                  disabled={data.data.csv.disable}
                                  onChange={(e) => {
                                    updateStatus(
                                      [data.data.id],
                                      e.target.checked,
                                      "csv"
                                    );
                                  }}
                                />
                                <label className="csv"></label>
                              </div>
                            </li>
                            <li>
                              <div className="Checkbox">
                                <input
                                  type="checkbox"
                                  name="check"
                                  checked={data.data.upload.check}
                                  defaultChecked={data.data.upload.check}
                                  disabled={data.data.upload.disable}
                                  onChange={(e) => {
                                    updateStatus(
                                      [data.data.id],
                                      e.target.checked,
                                      "upload"
                                    );
                                  }}
                                />
                                <label className="upload"></label>
                              </div>
                            </li>
                            <li>
                              <div className="Checkbox">
                                <input
                                  type="checkbox"
                                  name="check"
                                  checked={data.data.status.check}
                                  defaultChecked={data.data.status.check}
                                  disabled={data.data.status.disable}
                                  onChange={(e) => {
                                    updateStatus(
                                      [data.data.id],
                                      e.target.checked,
                                      "status"
                                    );
                                  }}
                                />
                                <label className="status"></label>
                              </div>
                            </li>
                            <li>
                              <div className="Checkbox">
                                <input
                                  type="checkbox"
                                  name="check"
                                  checked={data.data.add.check}
                                  defaultChecked={data.data.add.check}
                                  disabled={data.data.add.disable}
                                  onChange={(e) => {
                                    updateStatus(
                                      [data.data.id],
                                      e.target.checked,
                                      "add"
                                    );
                                  }}
                                />
                                <label className="add"></label>
                              </div>
                            </li>
                            <li>
                              <div className="Checkbox">
                                <input
                                  type="checkbox"
                                  name="check"
                                  checked={data.data.remove.check}
                                  defaultChecked={data.data.remove.check}
                                  disabled={data.data.remove.disable}
                                  onChange={(e) => {
                                    updateStatus(
                                      [data.data.id],
                                      e.target.checked,
                                      "remove"
                                    );
                                  }}
                                />
                                <label className="remove"></label>
                              </div>
                            </li>
                          </>
                        ) : data?.child.length > 0 ? null : (
                          <>
                            <li>
                              <div className="Checkbox">
                                <input
                                  type="checkbox"
                                  name="check"
                                  checked={data.data.view.check}
                                  defaultChecked={data.data.view.check}
                                  disabled={data.data.view.disable}
                                  onChange={(e) => {
                                    updateStatus(
                                      [data.data.id],
                                      e.target.checked,
                                      "view"
                                    );
                                  }}
                                />
                                <label className="view"></label>
                              </div>
                            </li>
                            <li>
                              <div className="Checkbox">
                                <input
                                  type="checkbox"
                                  name="check"
                                  checked={data.data.edit.check}
                                  defaultChecked={data.data.edit.check}
                                  disabled={data.data.edit.disable}
                                  onChange={(e) => {
                                    updateStatus(
                                      [data.data.id],
                                      e.target.checked,
                                      "edit"
                                    );
                                  }}
                                />
                                <label className="edit"></label>
                              </div>
                            </li>
                            <li>
                              <div className="Checkbox">
                                <input
                                  type="checkbox"
                                  name="check"
                                  checked={data.data.csv.check}
                                  defaultChecked={data.data.csv.check}
                                  disabled={data.data.csv.disable}
                                  onChange={(e) => {
                                    updateStatus(
                                      [data.data.id],
                                      e.target.checked,
                                      "csv"
                                    );
                                  }}
                                />
                                <label className="csv"></label>
                              </div>
                            </li>
                            <li>
                              <div className="Checkbox">
                                <input
                                  type="checkbox"
                                  name="check"
                                  checked={data.data.upload.check}
                                  defaultChecked={data.data.upload.check}
                                  disabled={data.data.upload.disable}
                                  onChange={(e) => {
                                    updateStatus(
                                      [data.data.id],
                                      e.target.checked,
                                      "upload"
                                    );
                                  }}
                                />
                                <label className="upload"></label>
                              </div>
                            </li>
                            <li>
                              <div className="Checkbox">
                                <input
                                  type="checkbox"
                                  name="check"
                                  checked={data.data.status.check}
                                  defaultChecked={data.data.status.check}
                                  disabled={data.data.status.disable}
                                  onChange={(e) => {
                                    updateStatus(
                                      [data.data.id],
                                      e.target.checked,
                                      "status"
                                    );
                                  }}
                                />
                                <label className="status"></label>
                              </div>
                            </li>
                            <li>
                              <div className="Checkbox">
                                <input
                                  type="checkbox"
                                  name="check"
                                  checked={data.data.add.check}
                                  defaultChecked={data.data.add.check}
                                  disabled={data.data.add.disable}
                                  onChange={(e) => {
                                    updateStatus(
                                      [data.data.id],
                                      e.target.checked,
                                      "add"
                                    );
                                  }}
                                />
                                <label className="add"></label>
                              </div>
                            </li>
                            <li>
                              <div className="Checkbox">
                                <input
                                  type="checkbox"
                                  name="check"
                                  checked={data.data.remove.check}
                                  defaultChecked={data.data.remove.check}
                                  disabled={data.data.remove.disable}
                                  onChange={(e) => {
                                    updateStatus(
                                      [data.data.id],
                                      e.target.checked,
                                      "remove"
                                    );
                                  }}
                                />
                                <label className="remove"></label>
                              </div>
                            </li>
                          </>
                        )}
                      </ul>
                    }
                  </>
                ))}
              </div>
            </div>
          </div>
        </Grid>
      </Grid>
    </div>
  );
}

export default ModulePermissionAccessControl;
